import { Card } from 'components/Card'
import { ArticleTeaser } from 'components/_base/ArticleTeaser'
import { Column } from 'components/_base/Column'
import { ContentGrid } from 'components/_base/ContentGrid'
import React, { useEffect, useState } from 'react'
import { csvParse, autoType } from 'd3-dsv'
const isMobile = window.innerWidth < 600
import useWindowSize from './useWindowSize'

import styled from 'styled-components'
type languages = 'de' | 'fr'
const params = new URL(window.location.toString())
const elementIds = params.searchParams
  .get('elements')
  ?.split(',')
  .map(Number)
const title = params.searchParams.get('title')
const sub = params.searchParams.get('sub')
const teaserTitle = params.searchParams.get('teasertitle')
const teaserKicker = params.searchParams.get('teaserkicker')
const url = params.searchParams.get('url')
const lang: 'de' | 'fr' = (params.searchParams.get('lang') as languages) || 'de'

const MFContainer = styled.div``

const contentheight = isMobile ? 220 : 220

type typeLang = 'de' | 'fr'
const defaultLabels: { [k in typeLang]: { [key: string]: any } } = {
  de: {
    title: 'Zutaten die aus der Schweiz erhältlich sind',
    sub: 'Weitere finden Sie hier',
    teaserTitle:
      'Diese Schweizer Obst- und Gemüsesorten sind aktuell erhältlich',
    teaserKicker: 'Nachhaltig einkaufen',
    URL: '2022/obst-und-gemuese-kalender/'
  },
  fr: {
    title: 'Zutaten die aus der Schweiz erhältlich sind',
    sub: 'Weitere finden Sie hier',
    teaserTitle: 'Voici les fruits et légumes actuellement de saison en Suisse',
    teaserKicker: 'Manger mieux et écolo?',
    URL: '2022/fruits-et-legumes-de-saison/'
  }
}

const Labels = {
  title: title || defaultLabels[lang as typeLang].title,
  sub: sub || defaultLabels[lang as typeLang].sub,
  teaserTitle: teaserTitle || defaultLabels[lang as typeLang].teaserTitle,
  teaserKicker: teaserKicker || defaultLabels[lang as typeLang].teaserKicker,
  URL: url || defaultLabels[lang as typeLang].URL
}

export const MF = ({ title = Labels.title }: { title?: string }) => {
  const [drawData, setdrawData] = React.useState<FruitElementType[]>()
  const width = useWindowSize()
  const [isMobile, setMobile] = useState(false)

  useEffect(() => {
    if (!width) return
    setMobile(width < 600)
  }, [width])

  React.useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/obst-und-gemuesekalender/data.csv'
    )
      .then(a => a.text())
      .then(a => {
        let full: FruitElementType[] = csvParse(a, autoType).map(
          (element: { [key: string]: any }) => {
            return element as FruitElementType
          }
        )
        let week = getWeek(new Date())
        const sortByChecked = (
          a: FruitElementType | undefined,
          b: FruitElementType
        ) => (a.hasSeason ? (b.hasSeason ? 1 : -1) : 1)

        let byid: FruitElementType[] = []
        if (elementIds) {
          elementIds.map((id, i) => {
            byid[i] = full.find(f => +f.id === id)
          })
        }

        full = full.map(f => {
          let hasSeason = false
          if (
            week === getWeek(new Date()) &&
            f.checked &&
            f.checkedAndAvailable
          )
            hasSeason = true

          if (+f.normfrom <= +f.normto) {
            if (+f.normfrom <= week && +f.normto >= week) hasSeason = true
          }

          if (+f.normfrom > +f.normto) {
            if (week <= +f.normfrom && week <= +f.normto) hasSeason = true
          }
          f.hasSeason = hasSeason
          if (hasSeason) f.activeColor = week === getWeek(new Date())

          return f
        })
        full = full.filter(f => f.hasSeason)

        console.log(elementIds)
        while (byid.length < 6) {
          let el = full[Math.floor(Math.random() * full.length)]
          if (!byid.includes(el)) byid.push(el)
        }
        setdrawData(
          (byid.filter(f => f !== undefined) as FruitElementType[]).sort(
            sortByChecked
          )
        )
      })
  }, [])

  const Cards =
    drawData &&
    drawData.map((m, i) => {
      return (
        <CardHolder key={'CardKey_' + i} className='CardHolder'>
          <Card data={m} hasSeason={true} lang={lang} />
        </CardHolder>
      )
    })

  return (
    <MFContainer>
      {!isMobile && (
        <TeaserContainer className='TeaserContainer'>
          <FirstRow>
            <Title className='Title'>{title}</Title>
            <TeaserTitle>{Labels.sub}</TeaserTitle>
          </FirstRow>
          <SecondRow>
            <ContentHolder className='Content'>{Cards}</ContentHolder>
            <TeaserHolder className='TeaserHolder'>
              <ArticleTeaser
                link={Labels.URL}
                titleHead={Labels.teaserKicker}
                title={Labels.teaserTitle}
              />
            </TeaserHolder>
          </SecondRow>
        </TeaserContainer>
      )}

      {isMobile && (
        <TeaserContainer className='TeaserContainer'>
          <FirstRow>
            <Title className='Title'>{title}</Title>
          </FirstRow>
          <SecondRow>
            <ContentHolder className='Content'>{Cards}</ContentHolder>
          </SecondRow>
          <FirstRow>
            <TeaserTitle>{Labels.sub}</TeaserTitle>
          </FirstRow>
          <SecondRow>
            <ArticleTeaser
              link={Labels.URL}
              titleHead={Labels.teaserKicker}
              title={Labels.teaserTitle}
            />
          </SecondRow>
        </TeaserContainer>
      )}
    </MFContainer>
  )
}
export const monthnameslong: { [k in typeLang]: string[] } = {
  de: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember'
  ],
  fr: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember'
  ]
}
export const getWeek = (date: string | Date) => {
  var d = new Date(new Date(date).getTime())
  d.setHours(0, 0, 0, 0)
  // Thursday in current week decides the year.
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7))
  // January 4 is always in week 1.
  var week1 = new Date(d.getFullYear(), 0, 4)
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((d.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  )
}

const FirstRow = styled.div`
  padding-top: 20px;

  flex: 0 0 100%;
  display: flex;
  gap: 15px;
`
const SecondRow = styled.div`
  flex: 0 0 100%;
  display: flex;
  gap: 15px;
`
const ThirdRow = styled.div`
  flex: 0 0 100%;
  display: flex;
  gap: 15px;
  flex-direction: column;
`
const ContentHolder = styled.div`
  display: flex;
  flex: 0 0 65%;
  flex-wrap: wrap;
  height: 100%;
  @media only screen and (max-width: 600px) {
    flex: 0 0 calc(100%);
  }
`
const CardHolder = styled.div`
  box-sizing: border-box;
  flex: 0 0 33.333%;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  /* height: ${contentheight / 2}px; */

  @media only screen and (max-width: 600px) {
    flex: 0 0 calc(33.333%);
    height: 50%;
  }
`
const TeaserHolder = styled.div`
  flex: 0 0 calc(35% - 15px);
  /* min-height: 90px; */
  /* padding: 0px 14px 0px 14px; */
  /* padding-left: 15px; */
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    flex: 0 0 calc(50% - 15px);
  }
`

const TeaserContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  width: 100%;
  grid-column-start: 1;
  grid-column-end: -1;

  border-top: 3px solid var(--brandblue-main);
`
const Title = styled.h1`
  flex: 0 0 65%;
  font-family: var(--font-plex);
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin: 0;

  padding-bottom: 10px;
  line-height: 2.2rem;
  @media only screen and (max-width: 600px) {
    flex: 0 0 100%;
  }
`
const TeaserTitle = styled.h1`
  flex: 0 0 calc(35% - 15px);
  display: flex;
  align-items: flex-end;
  font-family: var(--font-plex);
  font-size: 15px;
  line-height: 2.2rem;
  font-weight: 400;
  width: 100%;
  margin: 0;

  padding-bottom: 10px;
  @media only screen and (max-width: 600px) {
    flex: 0 0 100%;
  }
`
